import { render, staticRenderFns } from "./TicketPriority.vue?vue&type=template&id=47aadda4"
import script from "./TicketPriority.vue?vue&type=script&lang=js"
export * from "./TicketPriority.vue?vue&type=script&lang=js"
import style0 from "./TicketPriority.vue?vue&type=style&index=0&id=47aadda4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports